import { useTranslation } from 'react-i18next';
import { Badge } from '@parrot-software/design-system';
import { AlertCircle } from '@parrot-software/design-system/icons';

interface PaymentAlertBadgeProps {
  label?: string;
}

/**
 * PaymentAlertBadge - Destructive badge signalling a payment problem.
 *
 * Reusable across surfaces (subscriptions list and block detail) for any
 * payment alert state: it defaults to the "Pago pendiente" copy (license
 * payment-required) but accepts a `label` override to surface the mapped
 * last-payment-error text (e.g. "Pago devuelto") while keeping the same
 * destructive style and alert icon.
 *
 * @param {Object} props - Component properties
 * @param {string} [props.label] - Optional badge text; defaults to the pending-payment copy
 * @returns {React.ReactElement} Destructive badge
 */
export const PaymentAlertBadge = ({ label }: PaymentAlertBadgeProps) => {
  const { t } = useTranslation('subscriptions');

  return (
    <Badge className="bg-destructive text-destructive-foreground hover:bg-destructive gap-1" variant="destructive">
      <AlertCircle className="w-3 h-3" />
      {label ?? t('paymentMethod.pendingPayment')}
    </Badge>
  );
};
